import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { afterSalesApi } from '../..'
import {
  GetPartnerResponsiblesResponse,
  PartnerResponsible
} from './getPartnerResponsibles.types'

export const getPartnerResponsibles = async (): Promise<
  PartnerResponsible[]
> => {
  const response = await afterSalesApi.get<GetPartnerResponsiblesResponse>(
    '/api/external/partner-responsibles'
  )

  return response.data.data ?? []
}

export const GET_PARTNER_RESPONSIBLES_QUERY_KEY = 'getPartnerResponsibles'

export const useGetPartnerResponsiblesQuery = (
  options?: ExtendableQueryOptions<PartnerResponsible[]>
) => {
  return useQuery({
    queryKey: [GET_PARTNER_RESPONSIBLES_QUERY_KEY],
    queryFn: getPartnerResponsibles,
    ...options
  })
}
